import axios from "axios";

/** Servicio de login,se encargará del consumo para el inicio de sesion */
const configService = {
  currentEnvironment: String,
  configItems: Object,
  currentConfig: Object,
  async getConfiguration() {
    try {
      let response = await axios.get("config.json");
      let data = response.data;

      if (data) {
        this.currentEnvironment = data.selected;
        this.configItems = data.environments;
        const current = this.configItems.find(
          (env) => env.name === this.currentEnvironment
        );
        if (current) {
          this.currentConfig = current;
        }
      }
    } catch (error) {
      console.log("error");
    }
  },
  isConfigurationValid() {
    let isValid = false;

    let hasEnvironment = !!this.currentEnvironment;
    let hasItems = this.configItems && this.configItems.length;
    let hasConfig = !!this.currentConfig;
    isValid = hasEnvironment && hasItems && hasConfig;

    if (isValid) {
      let hasAuth = !!this.currentConfig.AuthEndpoint;
      let hasApi = !!this.currentConfig.APiEndPoint;

      isValid = hasAuth && hasApi;
    }

    return isValid;
  }
};

export default configService;
